'use client';

import { memo, useEffect, useState } from 'react';

import dynamic from 'next/dynamic';

import { Notification } from '@/features/v2/notifications/types';

import UserMenu from '@/features/v2/shared/Header/components/UserMenu';
import { userUIStore } from '@/stores/userUIStore';
import HNavbar from '@/stories/organisms/navbar/Navbar';

import { RouteLogicProvider } from './components/RouteLogicProvider';
import { NavbarEffects } from './hooks/NavbarEffects';
import ButtonDeposit from '../../components/Finance/ButtonDeposit';

const WrapperFinance = dynamic(
  () => { return import('@/features/v2/shared/Header/components/Finance/Balance'); },
  { ssr: false, loading: () => { return null; } },
);

const BonusSteps = dynamic(
  () => { return import('@/features/Bonus/BonusSteps'); },
  { ssr: false, loading: () => { return null; } },
);

const DepositModal = dynamic(() => { return import('@/components/modals/DepositModal'); }, {
  ssr: false,
  loading: () => { return null; },
});

const NotificationsSheetDynamic = dynamic(
  () => {
    return import('@/features/v2/notifications').then((mod) => {
      return { default: mod.NotificationsSheetDynamic };
    });
  },
  {
    ssr: false,
    loading: () => {
      return null;
    },
  },
);

const NavbarPrivate = () => {
  const { isDepositModalOpen, toggleDepositModal } = userUIStore();
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    async function fetchNotifications() {
      try {
        setIsLoading(true);
        const response = await fetch('/api/notifications');

        if (response.ok) {
          const { data } = await response.json();
          setNotifications(data || []);

          const count = (data || []).filter((n: Notification) => {
            return !n.read && !n.deleted;
          }).length;
          setUnreadCount(count);
        } else {
          setNotifications([]);
          setUnreadCount(0);
        }
      } catch (error) {
        setNotifications([]);
        setUnreadCount(0);
      } finally {
        setIsLoading(false);
      }
    }

    fetchNotifications();
  }, []);

  return (
    <>
      <NavbarEffects />
      <RouteLogicProvider>
        {(showBonusOnRoute: boolean) => {
          return (
            <HNavbar
              content={(
                <>
                  { isDepositModalOpen && <DepositModal isDepositSheetOpen={isDepositModalOpen} setIsDepositSheetOpen={toggleDepositModal} /> }
                  {showBonusOnRoute && <BonusSteps />}
                  <ButtonDeposit />
                  <WrapperFinance />
                  <NotificationsSheetDynamic
                    notifications={notifications}
                    unreadCount={unreadCount}
                    isLoading={isLoading}
                  />                  
                  <div className="hidden md:flex items-center ml-3 mt-1 md:-mr-3">
                    <UserMenu />
                  </div>
                </>
              )}
              position="end"
            />
          );
        }}
      </RouteLogicProvider>
    </>
  );
};

export default memo(NavbarPrivate);
